// extracted by mini-css-extract-plugin
module.exports = {"status":"Status_status__WxdJT","paid":"Status_paid__-QwZR","open":"Status_open__3cppe"};